<app-card title="Simuladores de Flows">
  <p class="text-muted mb-15" style="font-size: 13px;">
    Ejecuta aquí la misma lógica que corre cuando un usuario completa el WhatsApp Flow
    correspondiente, sin necesidad de pasar por WhatsApp.
  </p>

  <mat-tab-group>
    <mat-tab label="Strive (Simulador de crédito)">
      <div class="tab-content">
        <app-strive-tester></app-strive-tester>
      </div>
    </mat-tab>
    <mat-tab label="Price Simulator">
      <div class="tab-content">
        <app-price-simulator-tester></app-price-simulator-tester>
      </div>
    </mat-tab>
    <mat-tab label="Logo (IA)">
      <div class="tab-content">
        <app-logo-flow-tester></app-logo-flow-tester>
      </div>
    </mat-tab>
    <mat-tab label="Flyers">
      <div class="tab-content">
        <app-flyers-tester></app-flyers-tester>
      </div>
    </mat-tab>
    <mat-tab label="Cima">
      <div class="tab-content">
        <app-cima-tester></app-cima-tester>
      </div>
    </mat-tab>
  </mat-tab-group>
</app-card>
